import { render, staticRenderFns } from "./updatePass.vue?vue&type=template&id=dc881258&scoped=true"
import script from "./updatePass.vue?vue&type=script&lang=js"
export * from "./updatePass.vue?vue&type=script&lang=js"
import style0 from "./updatePass.vue?vue&type=style&index=0&id=dc881258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc881258",
  null
  
)

export default component.exports